
import * as React from "react"
import { Typography, type TypographyProps } from "./base"

// Paragraph variants
export const P = React.forwardRef<HTMLParagraphElement, Omit<TypographyProps, "as">>(
  ({ className, size = "body", ...props }, ref) => (
    <Typography
      ref={ref}
      as="p"
      size={size}
      className={className}
      {...props}
    />
  )
)
P.displayName = "P"

// Small text variant
export const Small = React.forwardRef<HTMLElement, Omit<TypographyProps, "size" | "as">>(
  ({ className, ...props }, ref) => (
    <Typography
      ref={ref}
      as="small"
      size="small"
      className={className}
      {...props}
    />
  )
)
Small.displayName = "Small"

// Span text variant for inline text
export const Span = React.forwardRef<HTMLSpanElement, Omit<TypographyProps, "as">>(
  ({ className, ...props }, ref) => (
    <Typography
      ref={ref}
      as="span"
      className={className}
      {...props}
    />
  )
)
Span.displayName = "Span"

// Muted text variant
export const Muted = React.forwardRef<HTMLParagraphElement, Omit<TypographyProps, "variant" | "as">>(
  ({ className, size = "small", ...props }, ref) => (
    <Typography
      ref={ref}
      as="p"
      variant="muted"
      size={size}
      className={className}
      {...props}
    />
  )
)
Muted.displayName = "Muted"

// Subtle text variant - even more muted
export const Subtle = React.forwardRef<HTMLParagraphElement, Omit<TypographyProps, "variant" | "as">>(
  ({ className, size = "xs", ...props }, ref) => (
    <Typography
      ref={ref}
      as="p"
      variant="subtle"
      size={size}
      className={className}
      {...props}
    />
  )
)
Subtle.displayName = "Subtle"
